import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'

import { Button, Input, PageTransition, Icon } from '@components/atoms'
import ToastError from '@components/atoms/Error'
import { SliderLogin } from '@components/molecules'
import { yupResolver } from '@hookform/resolvers/yup'
import { loginStyles } from '@pages/Login/styles'
import { resetPassWordSchema } from '@schemas/auth/login.schema'
import { authApi } from '@services/AuthApi'

const { background, container } = loginStyles

type FormValues = {
	password: string
	retypePassword: string
}

export default function ResetPassword() {
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm<FormValues>({ resolver: yupResolver(resetPassWordSchema) })

	const [changePassword, { isLoading, isSuccess, data }] =
		authApi.useChangePasswordMutation()

	const navigation = useNavigate()
	const [searchParams] = useSearchParams()

	const onSubmit = handleSubmit((payload) => {
		if (searchParams.get('email') && searchParams.get('code')) {
			changePassword({
				password: payload.password,
				email: searchParams.get('email') || '',
				code: searchParams.get('code') || '',
			})
		}
	})

	useEffect(() => {
		if (isSuccess && data) {
			navigation('/login')
		}
	}, [isSuccess, data, navigation])

	return (
		<PageTransition>
			<main className={background()}>
				<div className={container()}>
					<Link to='/'>
						<Icon title='logo DLS' name='logo' width={116} height={50} />
					</Link>

					<div className='titles'>
						<h4>Refazer senha</h4>
						<p>Digite sua nova senha abaixo.</p>
					</div>

					<form onSubmit={onSubmit}>
						<Input
							placeholder='Senha'
							type='password'
							error={errors.password?.message}
							{...register('password')}
						/>
						<Input
							placeholder='Confirmar senha'
							type='password'
							error={errors.retypePassword?.message}
							{...register('retypePassword')}
						/>

						<Button
							onClick={onSubmit}
							css={{ marginBottom: '154px' }}
							loading={isLoading}
						>
							Entrar
						</Button>
					</form>

					<Link className='link' to='/login'>
						Me lembrei!
					</Link>
				</div>

				<SliderLogin />
				<ToastError />
			</main>
		</PageTransition>
	)
}
